import { render, staticRenderFns } from "./VehicleCategoryList.vue?vue&type=template&id=627cba9a&scoped=true&"
import script from "./VehicleCategoryList.vue?vue&type=script&setup=true&lang=js&"
export * from "./VehicleCategoryList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./VehicleCategoryList.vue?vue&type=style&index=0&id=627cba9a&prod&lang=css&"
import style1 from "./VehicleCategoryList.vue?vue&type=style&index=1&id=627cba9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627cba9a",
  null
  
)

export default component.exports